import Vue from 'vue'
import exportExcelVue from './main.vue'

const defaults = {
  loading: false,
  visible: false,
  type: 'object', // object array
  total: 0,
  fileType: 'xlsx',
  fileName: 'unnamed',
  fileHeader: null,
  fileData: [],
  request: null,
  requestParams: {},
  getResponseData: (data) => data,
  currentPage: 1,
  perPage: 50,
  retryTotal: 0,
  autoDownload: true,
  autoStart: true,
  backendRequestParams: {},
  /**
   * 开始 start
   * 停止 stop
   * 结束 end
   * 错误 error
   */
  status: ''
}

const ExportExcelConstructor = Vue.extend(exportExcelVue)

let currentMsg, instance
let msgQueue = []

const initInstance = () => {
  instance = new ExportExcelConstructor({
    el: document.createElement('div'),
  })
}

const showNextMsg = () => {
  if (!instance) {
    initInstance()
  }
  instance.action = ''

  if (!instance.visible || instance.closeTimer) {
    if (msgQueue.length > 0) {
      currentMsg = msgQueue.shift()

      let options = currentMsg.options
      for (let prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop]
        }
      }

      let oldCb = instance.callback
      instance.callback = (action, instance) => {
        oldCb(action, instance)
        showNextMsg()
      }

      document.body.appendChild(instance.$el)

      if (instance.status === 'end') {
        instance.download()
      } else {
        Vue.nextTick(() => {
          instance.visible = true
        })
      }
    }
  }
}

const ExportExcelBox = function (options) {
  msgQueue.push({
    options: Object.assign({}, defaults, options),
  })
  showNextMsg()
}

ExportExcelBox.export = (fileName, fileData, options = {}) => {
  // 直接传入数据导出
  if (Array.isArray(fileData)) {
    options.total = fileData.length
    options.status = 'end'
  } else {
    // 传入第二参数为 options
    options = fileData
    fileData = []
  }

  return ExportExcelBox(Object.assign({
    fileName,
    fileData,
  }, options))
}

export default ExportExcelBox
export { ExportExcelBox }



// WEBPACK FOOTER //
// ./core/components/ExportExcelBox/src/main.js